export interface BreadcrumbItem {
  label: string
  url?: string
}

const BreadcrumbsConfig: Record<string, BreadcrumbItem[]> = {
  '/': [{ label: 'Home', url: '/' }, { label: 'Dashboard' }],
  '/dashboard': [{ label: 'Home', url: '/' }, { label: 'Dashboard' }],
  '/organization': [{ label: 'Home', url: '/' }, { label: 'Team' }],
  '/compplan': [{ label: 'Home', url: '/' }, { label: 'Compensation Plan' }],
  '/my-rewards': [{ label: 'Home', url: '/' }, { label: 'My Rewards' }],
  '/admin/organizations/manage': [
    { label: 'Home', url: '/' },
    { label: 'Team', url: '/organization' },
    { label: 'Manage' },
  ],
  '/admin/users/profile': [
    { label: 'Home', url: '/' },
    { label: 'Team', url: '/organization' },
    { label: 'Team Member' },
  ],
  '/employee/:id/compplan': [
    { label: 'Home', url: '/' },
    { label: 'Team', url: '/organization' },
    { label: 'Employee Compensation Plan' },
  ],
  '/create-comp-plan': [
    { label: 'Home', url: '/' },
    { label: 'Team', url: '/organization' },
    { label: 'Compensation Plan' },
  ],
  '/organization/settings': [{ label: 'Home', url: '/' }, { label: 'Team' }],
  '/admin/templates': [
    { label: 'Home', url: '/' },
    { label: 'Templates', url: '/admin/templates' },
  ],
  '/admin/templates/create': [
    { label: 'Home', url: '/' },
    { label: 'Templates', url: '/admin/templates' },
    { label: 'Create Template' },
  ],
  '/admin/templates/:id/copy': [
    { label: 'Home', url: '/' },
    { label: 'Templates', url: '/admin/templates' },
    { label: 'Copy Template' },
  ],
  '/admin/templates/:id/edit': [
    { label: 'Home', url: '/' },
    { label: 'Templates', url: '/admin/templates' },
    { label: 'Edit Template' },
  ],
  '/admin/templates/:templateId/view': [
    { label: 'Home', url: '/' },
    { label: 'Templates', url: '/admin/templates' },
    { label: 'View Template' },
  ],
  '/admin/templates/select/:userId': [
    { label: 'Home', url: '/' },
    { label: 'Team', url: '/organization' },
    { label: 'Select Template' },
  ],
  '/admin/components/manage': [{ label: 'Home', url: '/' }, { label: 'Components' }],
  '/admin/components/create': [
    { label: 'Home', url: '/' },
    { label: 'Components', url: '/admin/components/manage' },
    { label: 'Create' },
  ],
  '/admin/components/:id/edit': [
    { label: 'Home', url: '/' },
    { label: 'Components', url: '/admin/components/manage' },
    { label: 'Edit' },
  ],
  '/admin/components/targets': [
    { label: 'Home', url: '/' },
    { label: 'Components', url: '/admin/components/targets' },
    { label: 'Targets' },
  ],
  '/admin/targets/edit': [
    { label: 'Home', url: '/' },
    { label: 'Components', url: '/admin/components/targets' },
    { label: 'Edit Target' },
  ],
  '/admin/components/actuals': [
    { label: 'Home', url: '/' },
    { label: 'Components', url: '/admin/components/actuals' },
    { label: 'Actuals' },
  ],
  '/admin/accruals': [{ label: 'Home', url: '/' }, { label: 'Accrual Progress' }],
  '/admin/accrual-ledger': [{ label: 'Home', url: '/' }, { label: 'Accrual Ledger' }],
  '/admin/approvals': [{ label: 'Home', url: '/' }, { label: 'Approvals' }],
  '/admin/approvals/:id/edit': [
    { label: 'Home', url: '/' },
    { label: 'Approvals', url: '/admin/approvals' },
    { label: 'Edit' },
  ],
  '/company-settings': [{ label: 'Home', url: '/' }, { label: 'Configuration' }, { label: 'Company Settings' }],
  '/admin/ledger-accounts': [{ label: 'Home', url: '/' }, { label: 'Configuration' }, { label: 'Ledger Accounts' }],
  '/period-settings': [{ label: 'Home', url: '/' }, { label: 'Configuration' }, { label: 'Period Settings' }],
  '/admin/plans': [{ label: 'Home', url: '/' }, { label: 'Plans' }],
  '/admin/period-plans': [{ label: 'Home', url: '/' }, { label: 'Plans' }],
  '/admin/close-periods': [{ label: 'Home', url: '/' }, { label: 'Configuration' }, { label: 'Close Periods' }],
  '/admin/components/targets/create': [
    { label: 'Home', url: '/' },
    { label: 'Components', url: '/admin/components/targets' },
    { label: 'Create Target' },
  ],
  '/admin/components/actuals/create': [
    { label: 'Home', url: '/' },
    { label: 'Components', url: '/admin/components/actuals' },
    { label: 'Create Actuals' },
  ],
  '/admin/metrics/edit': [
    { label: 'Home', url: '/' },
    { label: 'Components', url: '/admin/components/actuals' },
    { label: 'Edit Metric' },
  ],
  '/wizard': [{ label: 'Home', url: '/' }, { label: 'Jump Start Wizard' }],
  '/forms': [{ label: 'Home', url: '/' }, { label: 'Data Import' }, { label: 'Import Data' }],
  '/smart-import': [{ label: 'Home', url: '/' }, { label: 'Data Import' }, { label: 'Smart Import' }],
  '/reports/run': [{ label: 'Home', url: '/' }, { label: 'Run Reports' }],
  '/templates': [{ label: 'Home', url: '/' }, { label: 'Templates' }],
  '/setup-in-progress': [{ label: 'Home', url: '/' }, { label: 'Setup In Progress' }],
  '/profile': [{ label: 'Home', url: '/' }, { label: 'Profile' }],
  '/rewards/manage': [{ label: 'Home', url: '/' }, { label: 'Rewards' }],
  '/rewards/create': [
    { label: 'Home', url: '/' },
    { label: 'Rewards', url: '/rewards/manage' },
    { label: 'Create Rewards' },
  ],
  '/rewards/edit': [
    { label: 'Home', url: '/' },
    { label: 'Rewards', url: '/rewards/manage' },
    { label: 'Edit Rewards' },
  ],
  '/rewards/packages': [
    { label: 'Home', url: '/' },
    { label: 'Rewards', url: '/rewards/manage' },
    { label: 'Packages' },
  ],
  '/rewards/packages/create': [
    { label: 'Home', url: '/' },
    { label: 'Rewards', url: '/rewards/manage' },
    { label: 'Packages', url: '/rewards/packages' },
    { label: 'Create Package' },
  ],
  '/rewards/packages/edit': [
    { label: 'Home', url: '/' },
    { label: 'Rewards', url: '/rewards/manage' },
    { label: 'Packages', url: '/rewards/packages' },
    { label: 'Edit Package' },
  ],
  '/rewards/assign': [
    { label: 'Home', url: '/' },
    { label: 'Rewards', url: '/rewards/manage' },
    { label: 'Employee Rewards' },
  ],
  '/rewards/categories': [
    { label: 'Home', url: '/' },
    { label: 'Rewards', url: '/rewards/manage' },
    { label: 'Edit Categories' },
  ],
  '/rewards/:userId': [
    { label: 'Home', url: '/' },
    { label: 'Rewards', url: '/rewards/manage' },
    { label: 'Employee Rewards', url: '/rewards/assign' },
    { label: 'Total Rewards' },
  ],
  '/rewards/edit/:userId/:periodId': [
    { label: 'Home', url: '/' },
    { label: 'Rewards', url: '/rewards/manage' },
    { label: 'Employee Rewards', url: '/rewards/assign' },
    { label: 'Edit Rewards' },
  ],
}

export default BreadcrumbsConfig
